import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { requestForToken, onMessageListener } from "../services/firebase.service";
import { showToast } from "../redux/guest-slices/other.slice";

export const useFirebaseNotifications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { member, specialist } = useSelector((state) => state.authSlice);
  
  // Identify if any user is logged in
  const user = member || specialist;

  useEffect(() => {
    // Fetch token (requests permission if state is default)
    requestForToken();
  }, [user?._id]);

  useEffect(() => {
    if (user?._id) {
      // Listen to postMessage events from our custom service worker push handler
      const handleServiceWorkerMessage = (event) => {
        if (event.data) {
          if (event.data.type === "PUSH_RECEIVED") {
            console.log("Foreground message received via Service Worker postMessage:", event.data.payload);
            const payload = event.data.payload;
            dispatch(
              showToast({
                message: `${payload.notification?.title || "New Notification"}: ${payload.notification?.body || ""}`,
                type: "info",
                duration: 8000,
              })
            );
          } else if (event.data.action === "navigate") {
            console.log("Navigation instruction received from Service Worker:", event.data.url);
            navigate(event.data.url);
          }
        }
      };

      if (navigator.serviceWorker) {
        navigator.serviceWorker.addEventListener("message", handleServiceWorkerMessage);
      }

      // Keep the Firebase foreground listener as a fallback
      const unsubscribe = onMessageListener((payload) => {
        console.log("Foreground message received via Firebase onMessage:", payload);
        dispatch(
          showToast({
            message: `${payload.notification?.title}: ${payload.notification?.body}`,
            type: "info",
            duration: 8000,
          })
        );
      });

      return () => {
        if (navigator.serviceWorker) {
          navigator.serviceWorker.removeEventListener("message", handleServiceWorkerMessage);
        }
        if (typeof unsubscribe === "function") {
          unsubscribe();
        }
      };
    }
  }, [user?._id, dispatch, navigate]);
};
